import type React from "react";
import {memo, useCallback} from "react";

import {HStack} from "../ui/hstack";
import {Pressable} from "../ui/pressable";
import {Text} from "../ui/text";

import type {TagOption} from "./types";

interface TagOptionItemProps {
    option: TagOption;
    onSelect?: (option: TagOption) => void;
}

const TagOptionItem: React.FC<TagOptionItemProps> = ({option, onSelect}) => {
    const handlePress = useCallback(() => {
        onSelect?.(option);
    }, [onSelect, option]);

    const Item = (
        <HStack className="px-2 py-2 w-full justify-between" space="lg">
            <Text className="max-w-1/2" variant="sm">
                {option.label}
            </Text>
            <Text
                isParagraph
                className="max-w-1/2"
                color="blueGray.400"
                textAlign="right"
                variant="sm"
            >
                {option.value}
            </Text>
        </HStack>
    );

    if (onSelect) {
        return (
            <Pressable
                className="rounded-sm data-[focus=true]:bg-background-50 data-[active=true]:bg-background-100"
                onPress={handlePress}
            >
                {Item}
            </Pressable>
        );
    }

    return Item;
};

export default memo(TagOptionItem);
